import React, { useState } from 'react';
import GoogleLogin, { GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login';

import { GOOGLE_CLIENT_ID } from '../../config/constants';
import { requestDataWithOptions } from '../../config/services/datasets';
import { SERVER } from '../../config/server.config';
import { useUserState, useUserDispatch } from '../../store/hooks/user';
import { useHistory, useLocation } from 'react-router-dom';

type LocationState = { toReturn: string };

export default () => {

  const history = useHistory();
  const location: { state: LocationState} = useLocation();

  const user = useUserState();
  const { replaceSuccessLoginGoogleUser } = useUserDispatch();

  const [loginFailed, setLoginFailed] = useState(false);

  const responseGoogle = (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    console.error('Google Login Failed:', response);
  };

  const goBack = () => {
    if (location.state && location.state.toReturn) {
      history.push(location.state.toReturn);
    } else {
      history.push('/schedule');
    }
  };
  if (user.isLogged) {
    goBack();
  }

  const responseSuccess = async (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    const results = await requestDataWithOptions(SERVER.LOGIN, (response as GoogleLoginResponse).tokenId);
    if (results && results[0]) {
      replaceSuccessLoginGoogleUser({...response, ...results[0]});
    } else {
      setLoginFailed(true);
    }
  };

  return (
    <div className="bg-login">
      <div className="card-login">
        <h6>WELCOME TO</h6>
        <img src="assets/logo.svg" alt="" width="480px" className="logo" />
        <p>
          As &quot;The Official On-Field Player-Tracking Provider&quot; of the NFL, Zebra has helped the NFL and its teams by
          delivering valuable player performance and ball tracking data via our Zebra Sports Edge user interface.
        </p>
        <div id={'google-login'}>
          <GoogleLogin
            clientId={GOOGLE_CLIENT_ID || ''}
            buttonText="Sign in with Google"
            redirectUri={'/schedule'}
            onSuccess={responseSuccess}
            onFailure={responseGoogle}
            isSignedIn={true}
          />
        </div>
        {loginFailed && <div style={{color: 'red', marginTop: 10}}>Login Failed!</div>}
      </div>
      <div className="login-a">
        © Zebra Technologies, All Rights Reserved.
      </div>
      <div className="b-login">
        <label className="b-001" />
        <div className="b-content">
          <label className="line-01" />
          <label className="line-02" />
          <h6>ROTATION SPEED</h6>
          <h1>12.2</h1>
          <p>MPH</p>
        </div>
        <label className="b-002" />
        <div className="b-content-02">
          <img src="assets/images/graph-01.png" alt="" width="80px" />
          <label className="line-02" />
        </div>
        <label className="b-003" />
        <div className="b-content-03">
          <label className="line-01" />
          <h6>AVG. TOTAL DIST. (YDS)</h6>
          <h1>2139</h1>
          <label className="line-02" />
        </div>
      </div>
    </div>
  );
};
